import { Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SafeHtml } from '@angular/platform-browser';
import { AnimatedModalComponent } from '@app/shared/modals/animated-modal.component';

@Component({
  selector: 'app-alert-modal',
  template: `
    <div class="general-popup-content">
      <a
        href="#"
        (click)="$event.preventDefault(); reject()"
        class="icon close-popup"
        data-id="modalAlert-close-button"
      >
        <i class="fal fa-times"></i>
      </a>
      <!--
        <button class="close" [class.no-hero]="!hero" type="button" (click)="reject()">
          <i class="fal fa-times"></i>
        </button>
      -->
      <div class="general-popup-hero" *ngIf="hero">
        <div class="bonus-edg-value">
          <div translate>{{ hero }}</div>
        </div>
      </div>
      <div class="general-popup-text-wrap">
        <h2 translate>{{ title }}</h2>
        <p translate [innerHtml]="text"></p>
        <app-form-button class="btn primary" (click)="close()" translate data-id="modalAlert-ok-button">
          {{ ok }}
        </app-form-button>
        <app-form-button
          class="btn cancel"
          (click)="reject()"
          *ngIf="cancel"
          translate
          data-id="modalAlert-cancel-button"
        >
          {{ cancel }}
        </app-form-button>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        width: 100%;
      }
    `,
    `
      @media screen and (max-width: 676px) {
        .btn {
          display: block;
          width: 100%;
          margin-bottom: 10px;
        }
        .btn button {
          width: 100%;
        }
      }
    `,
  ],
})
export class AlertModalComponent extends AnimatedModalComponent {
  hero: string;
  title: string;
  text: string | SafeHtml;
  ok: string;
  cancel: string | null;
  constructor(private ref: NgbActiveModal, protected elRef: ElementRef, protected renderer: Renderer2) {
    super(elRef, renderer);
  }

  public close(): void {
    this.ref.close();
  }

  public reject(): void {
    this.ref.dismiss();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/alert-modal.component.ts